import styled from 'styled-components';
import { breakpoints, text, verticalGutter } from '../../styles';

export default styled.section`
  margin: ${verticalGutter}rem 0;
  font-weight: bold;

  a {
    text-decoration: none;
    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }

  .ui.items {
    margin: ${verticalGutter / 2}rem 0;
    .item {
      font-size: ${text.large};
      font-weight: bold;
    }
  }

  .meta,
  .header {
    text-transform: uppercase;
  }
  .meta {
    font-size: ${text.medium} !important;
  }
  .header:not(.meta) {
    font-weight: normal !important;
    padding-top: ${verticalGutter / 8}rem;
  }
  .description {
    margin: 0 !important;
  }

  @media only screen and (min-width: ${breakpoints.tablet}) {
    .ui.items {
      .item {
        margin: ${verticalGutter / 3}rem 0;
      }
    }

    .header:not(.meta) {
      max-width: percentage(1/3);
      flex-basis: percentage(1/3);
    }
    .description {
      max-width: percentage(2/3);
      flex-basis: percentage(2/3);
    }
  }

  @media only screen and (min-width: ${breakpoints.computer}) {
    .header:not(.meta) {
      max-width: percentage(1/4);
      flex-basis: percentage(1/4);
    }
    .description {
      max-width: percentage(3/4);
      flex-basis: percentage(3/4);
    }
  }
`;
